<template>
  <div>
    <router-view />
    <profile-settings-modal
      v-if="profileModalOpen"
      v-model="profileModalOpen"
      @close="setProfileModalOpen(false)"
    />
  </div>
</template>

<script>
import ProfileSettingsModal from '@/components/profile/ProfileSettingsModal.vue'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    ProfileSettingsModal
  },
  computed: {
    ...mapState(['profileModalOpen'])
  },
  methods: {
    ...mapActions(['setProfileModalOpen'])
  }
}
</script>

<style lang="scss">
@use '@/assets/scss/variables' as *;
@use '@/assets/scss/resets' as *;
@use '@/assets/scss/helpers' as *;
@use '@/assets/scss/utilities' as *;
@use '@/assets/scss/icons' as *;
@use '@/assets/scss/typography' as *;
@use '@/assets/scss/lists' as *;
@use '@/assets/scss/cards' as *;
@use '@/assets/scss/tables' as *;
@use '@/assets/scss/buttons' as *;
@use '@/assets/scss/labels' as *;
@use '@/assets/scss/loading' as *;
@use '@/assets/scss/avatars' as *;
@use '@/assets/scss/empty-states' as *;

// Global component styles
@use '@/assets/scss/tabs' as *;
@use '@/assets/scss/forms' as *;

// Global layout styles
@use '@/assets/scss/grid' as *;
@use '@/assets/scss/layouts/layout-sidebar' as *;
@use '@/assets/scss/layouts/layout-search-results' as *;
@use '@/assets/scss/layouts/layout-wizard' as *;

:root {
  --dark: #2e3242;
  --slate: #45555f;
  --gray: #717782;
  --gray400: #8f95a1;
  --blue: #009de0;
  --light-blue: #eef2f5;
  --magenta: #e9374f;
  --orange: #f9690e;
  --green: #199d5b;
}

body {
  background-color: $light-blue;
  overflow-x: hidden;
}
strong {
  font-weight: 600;
  color: $dark;
}
.scrollLock {
  overflow: hidden;
}
</style>
